<script lang="ts" setup>
import type {FreeResourceCategory} from '~/types/legacy'
import type {Populated} from '~/types/populated'
import {resolveMediaProps} from '~/utils/relations'

const props = defineProps<{
  category: Populated<FreeResourceCategory>
}>()

const route = useRoute()

const isActive = computed(() => {
  const selectedCategory = route.query.category as string
  const categoryName = props.category.name?.toLowerCase()

  if (categoryName === 'all') {
    return !selectedCategory || selectedCategory === 'all'
  }

  return selectedCategory === categoryName
})

const linkTo = computed(() => {
  const categoryName = props.category.name?.toLowerCase()

  if (categoryName === 'all') {
    const newQuery = {...route.query}
    delete newQuery.category
    return {query: newQuery}
  } else {
    return {
      query: {
        ...route.query,
        category: categoryName,
      },
    }
  }
})
</script>

<template>
  <NuxtLink
    :to="linkTo"
    :class="[
      'flex w-24 cursor-pointer flex-col items-center gap-3 rounded-lg border p-4 transition-all duration-200',
      isActive
        ? 'border-main-900 bg-main-50 shadow-sm'
        : 'border-transparent bg-white hover:bg-gray-100 hover:shadow-sm',
    ]"
  >
    <div class="flex max-w-7xl justify-start">
      <NuxtImg v-bind="resolveMediaProps(category.icon)" class="h-6 w-6 flex-shrink-0 object-contain" />
    </div>
    <Heading as="h3" size="small" class="text-center text-sm font-medium leading-tight text-gray-700">
      {{ category.name }}
    </Heading>
  </NuxtLink>
</template>
